import React from 'react';

// Import หน้าจอ BillOfLading มาแสดงบน Modal
import Form from '../../pages/Warehouse/BillOfLading/Form';

const BolModal = ({ showBolModal, handleBolClose, callInitialize, mode, name, whDocNo, pickingList }) => {
    return (
        <>
            <div className={`modal ${showBolModal ? 'show' : ''}`} style={{ display: showBolModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="card-title">{whDocNo}</h4>
                            <button type="button" className="close" onClick={handleBolClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <Form
                                callInitialize={callInitialize}
                                mode={mode}
                                name={name}
                                whDocNo={whDocNo}
                                pickingList={pickingList}
                            />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" onClick={handleBolClose}>ปิด</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BolModal;